import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'

import {App} from './App'

import {BoomTown} from './routes/BoomTown'
import {CopilotIndex} from './routes/CopilotIndex'
import {EnterpriseIndex} from './routes/EnterpriseIndex'
import {EnterpriseAdvancedSecurityIndex} from './routes/enterprise/AdvancedSecurityIndex'
import {ShowPage} from './routes/ShowPage'
import {DiversityIndex} from './routes/about/diversity/DiversityIndex'
import {CopilotPlansIndex} from './routes/copilot/PlansIndex'

registerReactAppFactory('landing-pages', () => ({
  App,
  routes: [
    jsonRoute({path: '/about/diversity', Component: DiversityIndex}),
    jsonRoute({path: '/features/copilot', Component: CopilotIndex}),
    jsonRoute({path: '/features/copilot/plans', Component: CopilotPlansIndex}),
    jsonRoute({path: '/enterprise', Component: EnterpriseIndex}),
    jsonRoute({path: '/enterprise/advanced-security', Component: EnterpriseAdvancedSecurityIndex}),

    /**
     * We use this route to exercise error handling and exception reporting.
     * in the app. The BoomTown component simply throws an error when it renders.
     */
    jsonRoute({path: '/contentful-lp-tests/boomtown', Component: BoomTown}),

    jsonRoute({path: '*', Component: ShowPage}),
  ],
}))
